<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_3 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<template v-if="isAccountManager">
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('cliccatore_id')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-autocomplete
							:items="cliccatoriNonAssegnati"
							v-model="pratica.cliccatore"
							return-object
							:loading="isLoadingCliccatoriNonAssegnati"
							label="Assegna un cliccatore"
							item-value="id"
							item-text="username_codice_cliccatore"
							outlined
							dense
							clearable
							@click:clear="pratica.cliccatore = Object.assign({}, praticaVoid.cliccatore)"
							:disabled="isLoading"
						></v-autocomplete>
					</v-badge>
				</v-col>
			</v-row>
		</template>
	
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_3: null,
				ci_sono_aggiornamenti_fase_3: false,
				cliccatore_id: null,
				cliccatore: {
					id: null,
					username: null,
					codice_cliccatore: null
				}
			},
			isLoadingCliccatoriNonAssegnati: false,
			cliccatoriNonAssegnati: []
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_3 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_3 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_3',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_3');
		}
		
		this.getCliccatoriNonAssegnati();
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingCliccatoriNonAssegnati;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		'pratica.cliccatore': function (cliccatore) {
			if (cliccatore === null) this.pratica.cliccatore = Object.assign({}, this.praticaVoid.cliccatore);
			this.pratica.cliccatore_id = this.pratica.cliccatore.id;
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		getCliccatoriNonAssegnati() {
			this.isLoadingCliccatoriNonAssegnati = true;
			axios.get(`/api/cliccatori-non-assegnati${this.pratica.cliccatore_id ? '?except=' + this.pratica.cliccatore_id : ''}`)
				.then(response => {
					this.cliccatoriNonAssegnati = response.data;
				})
				.finally(() => {
					this.isLoadingCliccatoriNonAssegnati = false;
				})
		}
	}
	
}
</script>

<style scoped>

</style>